import { apiSaveStep, API_STEPS } from "../api/apiSaveStep";
import { globalFormFieldsSet } from "./globalFormFields";
import { apiCheckFiscalCode } from "../api/checkFiscalCode";
import { fieldValidator } from "../utils/fieldValidator";
import { VALIDATORS_TYPE, ERROR_TEXTS } from "../utils/constants";
import { generateFiscalCode } from "../utils/generateFiscalCode";
import { getUserId } from "../utils/getUserId";

const FIELD_REQUIRED_MESSAGE = "Campo obbligatorio";

export const PERSONAL_DATA_FORM_FIELDS_NAMES = {
    email: 'email',
    surname: 'cognome',
    name: 'nome',
    emailConfirmation: 'confermaEmail',
    mobilePhone: 'cellulare',
    fiscalCode: 'codiceFiscale',
    isPrivacyAccepted: 'privacyAccettata',
    offerId: 'idOfferta',
    offerType: 'tipologiaOfferta',
    couponCode: 'codiceSconto',

    timeStart: 'timeStart',
    timeSpent: 'tempoImpiegato',

    nameError: 'nameError',
    surnameError: 'surnameError',
    emailError: 'emailError',
    emailConfirmationError: 'emailConfirmationError',
    mobilePhoneError: 'mobilePhoneError',
    fiscalCodeError: 'fiscalCodeError',
    isSubmittingForm: 'isSubmittingForm',
    errorFormSubmission: 'errorFormSubmission',

    analytic1: 'analytic1',
    analytic2: 'analytic2',
    analytic3: 'analytic3',
    referrer: 'referrer',
    vivigasUID: 'vivigasUID',
}

const defaultErrorState = {
    [PERSONAL_DATA_FORM_FIELDS_NAMES.nameError]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.surnameError]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.emailError]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmationError]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhoneError]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCodeError]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission]: ''
}

const initialState = {
    [PERSONAL_DATA_FORM_FIELDS_NAMES.name]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.surname]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.email]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmation]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.isPrivacyAccepted]: true,
    [PERSONAL_DATA_FORM_FIELDS_NAMES.timeSpent]: 0,
    [PERSONAL_DATA_FORM_FIELDS_NAMES.timeStart]: null,
    fiscalCodePopup: {
        isGenderMale: true,
        placeOfBirth: '',
        dateOfBirth: ''
    },

    [PERSONAL_DATA_FORM_FIELDS_NAMES.isSubmittingForm]: false,
    [PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission]: '',
    ...defaultErrorState,

    [PERSONAL_DATA_FORM_FIELDS_NAMES.analytic1]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.analytic2]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.analytic3]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.referrer]: '',
    [PERSONAL_DATA_FORM_FIELDS_NAMES.vivigasUID]: '',
};

const REQUIRED_FIELDS = [
    PERSONAL_DATA_FORM_FIELDS_NAMES.name,
    PERSONAL_DATA_FORM_FIELDS_NAMES.surname,
    PERSONAL_DATA_FORM_FIELDS_NAMES.email,
    PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmation,
    PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone,
    PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode,
];

const MAP_FIELD_ERROR = {
    [PERSONAL_DATA_FORM_FIELDS_NAMES.name]: PERSONAL_DATA_FORM_FIELDS_NAMES.nameError,
    [PERSONAL_DATA_FORM_FIELDS_NAMES.surname]: PERSONAL_DATA_FORM_FIELDS_NAMES.surnameError,
    [PERSONAL_DATA_FORM_FIELDS_NAMES.email]: PERSONAL_DATA_FORM_FIELDS_NAMES.emailError,
    [PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmation]: PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmationError,
    [PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone]: PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhoneError,
    [PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode]: PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCodeError,
}

const PERSONAL_DATA_CHANGE_TEXT_FIELD = 'PERSONAL_DATA_CHANGE_TEXT_FIELD';
export function personalDataChangeTextField(name, value) {
    return {
        type: PERSONAL_DATA_CHANGE_TEXT_FIELD,
        name,
        value
    }
}

export function personalDataSetAnalytics({ cx1 = '', cx2 = '', cx3 = '' }) {
    return dispatch => {
        dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.analytic1, cx1));
        dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.analytic2, cx2));
        dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.analytic3, cx3));
    }
}

export const personalDataSetReferrer = referrer => dispatch => dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.referrer, referrer));

const PERSONAL_DATA_PRIVACY_CHANGE = 'PERSONAL_DATA_PRIVACY_CHANGE';
export function personalDataPrivacyChange(isPrivacyAccepted) {
    return {
        type: PERSONAL_DATA_PRIVACY_CHANGE,
        isPrivacyAccepted
    }
}

const PERSONAL_DATA_FISCAL_CODE_POPUP_TEXT_CHANGE = 'PERSONAL_DATA_FISCAL_CODE_POPUP_TEXT_CHANGE';
export function personalDataPopupTextChange(name, value) {
    return {
        type: PERSONAL_DATA_FISCAL_CODE_POPUP_TEXT_CHANGE,
        name,
        value
    }
}

const PERSONAL_DATA_FISCAL_CODE_POPUP_GENDER_CHANGE = 'PERSONAL_DATA_FISCAL_CODE_POPUP_GENDER_CHANGE';
export function personalDataPopupGenderChange(isGenderMale) {
    return {
        type: PERSONAL_DATA_FISCAL_CODE_POPUP_GENDER_CHANGE,
        isGenderMale
    }
}

const PERSONAL_DATA_SET_ERROR_TEXT = 'PERSONAL_DATE_SET_ERROR_TEXT';
function personalDataSetErrorText(name, value) {
    return {
        type: PERSONAL_DATA_SET_ERROR_TEXT,
        name,
        value
    }
}

const PERSONAL_DATA_RESET_ERROR = 'PERSONAL_DATA_RESET_ERROR';
export function personalDataResetError(name) {
    return { type: PERSONAL_DATA_RESET_ERROR, name }
}

export function calculateFiscalCode() {
    return (dispatch, getState) => {
        try {
            const { personalDataForm } = getState();
            const { fiscalCodePopup } = personalDataForm;
            console.log('Calculating fiscal code');

            const user = generateFiscalCode({
                placeOfBirth: fiscalCodePopup.placeOfBirth,
                dateOfBirth: fiscalCodePopup.dateOfBirth,
                name: personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.name],
                surname: personalDataForm[PERSONAL_DATA_FORM_FIELDS_NAMES.surname],
                gender: fiscalCodePopup.isGenderMale
            })

            console.log(user);
            if (user) {
                dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode, user.code));
            }
        } catch (error) {
            console.log(error);
        }
    }
}

const PERSONAL_DATA_FORM_SET_USER_FROM_MODEL = 'PERSONAL_DATA_FORM_SET_USER_FROM_MODEL';
export function personalDataFormSetFromModel(user) {
    const state = { ...user.firstStep }
    return { type: PERSONAL_DATA_FORM_SET_USER_FROM_MODEL, state };
}

export function personalDataFormValidateAndSubmit(shouldCheckFiscalCode = true) {
    return async (dispatch, getState) => {
        const { personalDataForm, offer, globalFormFieldsReducer } = getState();
        const form = { ...personalDataForm };
        const otp = globalFormFieldsReducer.otp;
        let error = false;

        // Reset the form submission error
        // dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, ''));
        dispatch(personalDataResetError());

        // Check if all the fields are populated
        for (let field of REQUIRED_FIELDS) {
            if (!form[field] || form[field].length < 0) {
                dispatch(personalDataSetErrorText(MAP_FIELD_ERROR[field], FIELD_REQUIRED_MESSAGE));
                error = true;
            }
        }
        if (error) {
            dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, ERROR_TEXTS.fieldsRequired));
            throw "Missing required fields";
        }

        // Check if the email confirmation matches the email
        if (form[PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmation] !== form[PERSONAL_DATA_FORM_FIELDS_NAMES.email]) {
            dispatch(personalDataSetErrorText(PERSONAL_DATA_FORM_FIELDS_NAMES.emailConfirmationError, 'Non uguale alla email'));
            error = true;
        }
        if (error) {
            dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, ERROR_TEXTS.globalValidationError));
            throw "Email not matching";
        }

        if (!fieldValidator(form[PERSONAL_DATA_FORM_FIELDS_NAMES.email], VALIDATORS_TYPE.email)) {
            dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.emailError, ERROR_TEXTS.validationError));
            dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, ERROR_TEXTS.globalValidationError));
            throw "Wrong email format";
        }

        if (!form[PERSONAL_DATA_FORM_FIELDS_NAMES.isPrivacyAccepted]) {
            dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, ERROR_TEXTS.privacyNotAccepted));
            throw "Privacy not accepted";
        }

        if (!fieldValidator(form[PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhone], VALIDATORS_TYPE.isPhoneValid)) {
            dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.mobilePhoneError, ERROR_TEXTS.validationError));
            dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, ERROR_TEXTS.phoneInvalidFormat));
            throw "Invalid phone";
        }

        try {
            fieldValidator(
                form[PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode],
                VALIDATORS_TYPE.fiscalCode,
            );
        } catch (error) {
            if (error === 'invalid') {
                dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCodeError, ERROR_TEXTS.invalidFiscalCode));
                dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, ERROR_TEXTS.invalidFiscalCode));
                throw 'invalid fiscal code';
            } else {
                dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCodeError, ERROR_TEXTS.ageFiscalCode));
                dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, ERROR_TEXTS.ageFiscalCode));
                throw 'invalid fiscal age';
            }
        }

        // Set is submitting to true when we start the requests
        dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.isSubmittingForm, true));

        // Check if the fiscal code is already in use
        if (shouldCheckFiscalCode) {
            let isActive = false;
            try {
                isActive = await apiCheckFiscalCode(form[PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCode]);
            } catch (error) {
                console.log('Error checking fiscal code');
                dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.isSubmittingForm, false));
                dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, 'Errore nel controllare il codice fiscale.'));
                throw "Error checking fiscal code";
            }

            if (isActive) {
                console.log('CF active');
                dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.isSubmittingForm, false));
                dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, 'Codice fiscale già in uso, accedi all’area clienti.'));
                dispatch(personalDataSetErrorText(PERSONAL_DATA_FORM_FIELDS_NAMES.fiscalCodeError, 'Codice fiscale già in uso.'));
                throw "CF already in use";
            }
        }

        // Save the data
        let timeSpent = form[PERSONAL_DATA_FORM_FIELDS_NAMES.timeSpent];
        if (shouldCheckFiscalCode) {
            timeSpent = form[PERSONAL_DATA_FORM_FIELDS_NAMES.timeSpent]
                + parseInt(Date.now() / 1000, 10) - form[PERSONAL_DATA_FORM_FIELDS_NAMES.timeStart];
        }

        dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.timeSpent, timeSpent));
        form[PERSONAL_DATA_FORM_FIELDS_NAMES.timeSpent] = timeSpent;

        let response = '';
        try {
            response = await apiSaveStep(API_STEPS.first, {
                ...form,
                otp,
                [PERSONAL_DATA_FORM_FIELDS_NAMES.offerId]: offer.offerId,
                [PERSONAL_DATA_FORM_FIELDS_NAMES.offerType]: offer.offerType,
                [PERSONAL_DATA_FORM_FIELDS_NAMES.couponCode]: offer.coupon,
                //aggiungo il cookie vivigasUid
                [PERSONAL_DATA_FORM_FIELDS_NAMES.vivigasUID]: document.cookie.replace(/(?:(?:^|.*;\s*)VivigasUId\s*\=\s*([^;]*).*$)|^.*$/, "$1"),
            });
        } catch (error) {
            console.log("Error submitting first step");
            dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.errorFormSubmission, 'Errore nel salvare i dati.'));
            throw "Error saving data";
        } finally {
            dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.isSubmittingForm, false));
        }

        // Save the email to the global state
        dispatch(globalFormFieldsSet('email', form[PERSONAL_DATA_FORM_FIELDS_NAMES.email]));
        dispatch(globalFormFieldsSet('userId', getUserId(response.data.userId)));
        dispatch(globalFormFieldsSet('otp', response.data.otp));

        dispatch(personalDataChangeTextField(PERSONAL_DATA_FORM_FIELDS_NAMES.isSubmittingForm, false));
    }
}

export function personalDataForm(state = initialState, action) {
    switch (action.type) {
        case PERSONAL_DATA_CHANGE_TEXT_FIELD: {
            return { ...state, [action.name]: action.value };
        }
        case PERSONAL_DATA_PRIVACY_CHANGE: {
            return { ...state, [PERSONAL_DATA_FORM_FIELDS_NAMES.isPrivacyAccepted]: action.isPrivacyAccepted }
        }
        case PERSONAL_DATA_FISCAL_CODE_POPUP_TEXT_CHANGE: {
            return { ...state, fiscalCodePopup: { ...state.fiscalCodePopup, [action.name]: action.value } }
        }
        case PERSONAL_DATA_FISCAL_CODE_POPUP_GENDER_CHANGE: {
            return { ...state, fiscalCodePopup: { ...state.fiscalCodePopup, isGenderMale: action.isGenderMale } }
        }
        case PERSONAL_DATA_FORM_SET_USER_FROM_MODEL: {
            return { ...state, ...action.state }
        }
        //errors
        case PERSONAL_DATA_SET_ERROR_TEXT: {
            return { ...state, [action.name]: action.value }
        }
        case PERSONAL_DATA_RESET_ERROR: {
            if (!action.name) {
                return { ...state, ...defaultErrorState }
            } else {
                return { ...state, [action.name]: '' }
            }
        }

        default: {
            return state;
        }
    }
}